import reducers from "./reducers";
import sagas from "./sagas";

export default {
    name: "candidate",
    reducers,
    sagas,
};
